import { useRef } from 'react';
import PropTypes from 'prop-types';

import { useSoyuzClientConfig } from '@spotahome/soyuz/client';

import { ListingShape } from '@spotahome/marketplace-common/src/shapes/listing';
import BookNowCard from '@spotahome/marketplace-common/src/components/BookNowCard/BookNowCard';
import BookNowCardNotAvailable from '@spotahome/marketplace-common/src/components/BookNowCard/BookNowCardNotAvailable';

import ValuePropositionFeatures from '../ValuePropositionFeatures';
import { BOOKING_STATUSES } from '../../constants';

import './ListingBookNowCard.scss';

const ListingBookNowCard = ({
  listing,
  deviceType,
  moveIn = '',
  moveOut = '',
  bookingStatus,
  hasGAP = false,
  onBookingDatesChange,
  bookingRequestFormUrl = ''
}) => {
  const bookNowCard = useRef(null);
  const { dateFormat } = useSoyuzClientConfig();
  const handleDatesChange = ({ moveIn: newMoveIn, moveOut: newMoveOut }) =>
    onBookingDatesChange({ moveIn: newMoveIn, moveOut: newMoveOut });

  return (
    <div className="listing-bn">
      {!listing.moveInDatesRanges.length ? (
        <div ref={bookNowCard}>
          <BookNowCardNotAvailable listing={listing} deviceType={deviceType} />
        </div>
      ) : (
        <div id="js-booknow-card" data-test="booknow-card" ref={bookNowCard}>
          <BookNowCard
            bookingStatus={bookingStatus}
            bookingRequestFormUrl={bookingRequestFormUrl}
            hasGAP={hasGAP}
            moveIn={moveIn}
            moveOut={moveOut}
            onDatesChange={handleDatesChange}
            showSpinner={false} // @To-do: review
            listing={listing}
            deviceType={deviceType}
            dateFormat={dateFormat}
          />
        </div>
      )}
      <ValuePropositionFeatures listing={listing} />
    </div>
  );
};

ListingBookNowCard.propTypes = {
  listing: PropTypes.shape(ListingShape).isRequired,
  deviceType: PropTypes.oneOf(['smartphone', 'tablet', 'desktop']).isRequired,
  hasGAP: PropTypes.bool,
  bookingStatus: PropTypes.oneOf(Object.values(BOOKING_STATUSES)).isRequired,
  moveIn: PropTypes.string,
  moveOut: PropTypes.string,
  onBookingDatesChange: PropTypes.func.isRequired,
  bookingRequestFormUrl: PropTypes.string
};

export default ListingBookNowCard;
